import { Flex } from '@chakra-ui/react';
import { useAppDispatch, useAppSelector } from 'modules/Editor/store';
import { selectWidgetProperty } from 'modules/Editor/store/infographSelector';
import { updateWidget } from 'modules/Editor/store/infographSlice';
import { selectActiveWidgets } from 'modules/Editor/store/widgetSelector';
import { ReactElement, useCallback } from 'react';
import { LineWidgetData, LineWidgetTypes } from 'widgets/LineWidget/LineWidget.types';
import { useMultiWidgetValue } from 'widgets/sdk/Toolbar/MultiWidgetToolbar/MultiWidgetValueProvider';

import { LineWidgetToolbarContent } from './LineWidgetToolbarContent';

/**
 * MULTI LINE WIDGET TOOLBAR
 *
 * Displayed when multiple widgets are selected and all are line widgets
 */
export const MultiLineWidgetToolbar = (): ReactElement => {
  const dispatch = useAppDispatch();
  const activeWidgets = useAppSelector(selectActiveWidgets);

  const firstActiveWidgetId = activeWidgets[0]?.id;
  const type = useAppSelector(
    selectWidgetProperty<LineWidgetData, 'type'>(firstActiveWidgetId, 'type'),
  ) as LineWidgetTypes;
  const { color: strokeColor } = useMultiWidgetValue();
  const strokeWidth = useAppSelector(
    selectWidgetProperty<LineWidgetData, 'strokeWidth'>(firstActiveWidgetId, 'strokeWidth'),
  );
  const strokeDashType = useAppSelector(
    selectWidgetProperty<LineWidgetData, 'strokeDashType'>(firstActiveWidgetId, 'strokeDashType'),
  );
  const startArrowStyle = useAppSelector(
    selectWidgetProperty<LineWidgetData, 'startArrowStyle'>(firstActiveWidgetId, 'startArrowStyle'),
  );
  const endArrowStyle = useAppSelector(
    selectWidgetProperty<LineWidgetData, 'endArrowStyle'>(firstActiveWidgetId, 'endArrowStyle'),
  );

  const updateWidgets = useCallback(
    (updateData: Partial<LineWidgetData>) => {
      const batchUpdateList = activeWidgets.map((widget) => ({
        widgetId: widget.id,
        widgetData: updateData,
      }));

      dispatch(updateWidget(batchUpdateList));
    },
    [activeWidgets, dispatch],
  );

  return (
    <Flex mr='8px' gap='8px' align='center'>
      <LineWidgetToolbarContent
        values={{
          strokeColor: strokeColor! as string[],
          strokeWidth: strokeWidth!,
          strokeDashType: strokeDashType!,
          startArrowStyle: startArrowStyle!,
          endArrowStyle: endArrowStyle!,
          type: type!,
        }}
        onUpdate={updateWidgets}
      />
    </Flex>
  );
};
